import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=37d0ccd5&scoped=true&"
import script from "./BaseNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavigation.vue?vue&type=style&index=0&id=37d0ccd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0ccd5",
  null
  
)

export default component.exports